export default "/assets/images/mila-valentine.webp?8d31bbddf47a7b464608b3bcb0b42cdc";